import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { GameProvider } from './context/GameContext';
import { ToastProvider } from './context/ToastContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Navbar } from './components/Navbar';
import { BackToTop } from './components/BackToTop';
import { PrivateRoute } from './components/PrivateRoute';
import { GameHome } from './pages/GameHome';
import { CasinoSlots } from './pages/CasinoSlots';
import { CasinoDice } from './pages/CasinoDice';
import { CasinoRoulette } from './pages/CasinoRoulette';
import { CasinoWheel } from './pages/CasinoWheel';
import { CasinoBlackjack } from './pages/CasinoBlackjack';
import { CasinoScratch } from './pages/CasinoScratch';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Profile } from './pages/Profile';
import { NotFound } from './pages/NotFound';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <GameProvider>
            <ToastProvider>
              <div className="App">
                <Navbar />
                <Routes>
                  <Route path="/" element={<GameHome />} />
                  <Route path="/game/slots" element={<CasinoSlots />} />
                  <Route path="/game/dice" element={<CasinoDice />} />
                  <Route path="/game/roulette" element={<CasinoRoulette />} />
                  <Route path="/game/wheel" element={<CasinoWheel />} />
                  <Route path="/game/blackjack" element={<CasinoBlackjack />} />
                  <Route path="/game/scratch" element={<CasinoScratch />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <BackToTop />
              </div>
            </ToastProvider>
          </GameProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
